module.exports = __webpack_public_path__ + "static/media/nodata.b3c278d3.png";